/**
 * Family Settings Page
 *
 * Settings page for family members
 */

import React from 'react';

export const FamilySettings: React.FC = () => {
  return (
    <div className="flex items-center justify-center min-h-[calc(100vh-12rem)]">
      <div className="text-center space-y-6 max-w-2xl px-6">
        <h1 className="text-3xl font-bold text-gray-900">Settings</h1>
        <div className="mt-12">
          <p className="text-4xl font-semibold text-gray-400">Coming soon...</p>
        </div>
      </div>
    </div>
  );
};
